// unmanaged
// "Move to project…" for one upload or run (project-grouping PRD, R4). Staff
// pick any company's open project, or none (the Metalytics catch-all);
// customers pick one of their company's open projects, or none. Moving an
// upload offers to move the runs made from it too.
import React, { useEffect, useState } from "react";
import {
  Alert, Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, FormControlLabel, TextField,
} from "@mui/material";
import { moveItems } from "./projectApi";
import { ProjectPicker } from "./ProjectTagField";

export default function MoveToProjectDialog({ item, projectTags, onClose, onMoved }) {
  const isInput = item?.type === "input";
  const [value, setValue] = useState(null);
  const [withRuns, setWithRuns] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (item) {
      setValue(item.current || null);
      setWithRuns(true);
      setError(null);
    }
  }, [item]);

  const staff = projectTags?.staff;
  const openTags = (projectTags?.tags || []).filter((t) => t.open).map((t) => t.name);
  const save = async () => {
    setBusy(true);
    setError(null);
    try {
      await moveItems({
        staff,
        projectId: value,
        projectTag: value,
        inputIds: isInput ? [item.id] : [],
        runIds: isInput ? [] : [item.id],
        withRuns: isInput && withRuns,
      });
      onMoved?.();
      onClose();
    } catch (e) {
      setError(e?.message || "Couldn't move it");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!item} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Move to project</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2, overflowWrap: "anywhere" }}>{item?.label}</DialogContentText>
        {staff ? (
          <ProjectPicker value={value} onChange={setValue} projects={projectTags?.projects} label="Project"
                         helperText="Leave empty to take it out of every project." />
        ) : (
          <Autocomplete
            options={openTags}
            value={value}
            onChange={(_, v) => setValue(v || null)}
            renderInput={(params) => (
              <TextField {...params} label="Project" helperText="Leave empty to take it out of every project." />
            )}
          />
        )}
        {isInput && (
          <FormControlLabel
            sx={{ mt: 1 }}
            control={<Checkbox checked={withRuns} onChange={(_, v) => setWithRuns(v)} />}
            label="Also move the runs made from this file"
          />
        )}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" onClick={save} disabled={busy}>{busy ? "Moving…" : "Move"}</Button>
      </DialogActions>
    </Dialog>
  );
}
